
const guardedRoutes =["/management",'/store']

export default guardedRoutes